var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('div',{staticClass:"tl-logo__wrapper"},[_c('a-image',{attrs:{"url":_vm.companyLink,"image":_vm.logo,"width":150,"aspect-ratio":_vm.aspectRatios.thoughtLeadershipLogo}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }